import React from 'react';
import { cx, useRuntimeCss } from '../../../shared/styles/runtimeCss';
import { buildThemeVariables, getSectionWidthClass, getViewportWidth } from './rendererShared';
import { renderSectionContent } from './sectionRendererRegistry';
import './website-rendering.css';

function WebsiteSectionSlot({
  section,
  theme,
  css,
  viewportWidth,
  mode,
  isMobile,
  onWeddingGalleryPhotoUpload,
  onBestMenAndMaidsPhotoUpload,
}) {
  return (
    <div
      className={cx(
        'website-sections-canvas__section',
        `website-sections-canvas__section--${mode}`,
        `website-sections-canvas__section--${section.type}`,
        getSectionWidthClass(section.styles?.width),
        section.type === 'hero' && 'website-sections-canvas__section--hero'
      )}
    >
      {renderSectionContent({
        section,
        theme,
        css,
        viewportWidth,
        mode,
        isMobile,
        onWeddingGalleryPhotoUpload,
        onBestMenAndMaidsPhotoUpload,
      })}
    </div>
  );
}

function WebsiteSectionsCanvas({
  sections = [],
  theme,
  mode = 'viewer',
  isMobile = false,
  customCss = '',
  canvasClassName,
  onWeddingGalleryPhotoUpload,
  onBestMenAndMaidsPhotoUpload,
}) {
  const css = useRuntimeCss();
  const viewportWidth = getViewportWidth();
  const themeScopeClass = css(buildThemeVariables(theme));

  return (
    <div className={cx('website-theme-scope', `website-theme-scope--${mode}`, themeScopeClass)}>
      {customCss ? <style>{customCss}</style> : null}
      <div className={cx('website-sections-canvas', `website-sections-canvas--${mode}`, canvasClassName)}>
        {mode === 'preview' && typeof console !== 'undefined' ? console.debug('Preview sections:', sections.map(s => ({ id: s.id, type: s.type, props: s.props }))) : null}
        {sections.map((section) => (
          <WebsiteSectionSlot
            key={section.id}
            section={section}
            theme={theme}
            css={css}
            viewportWidth={viewportWidth}
            mode={mode}
            isMobile={isMobile}
            onWeddingGalleryPhotoUpload={onWeddingGalleryPhotoUpload}
            onBestMenAndMaidsPhotoUpload={onBestMenAndMaidsPhotoUpload}
          />
        ))}
      </div>
    </div>
  );
}

export default WebsiteSectionsCanvas;
